import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";
import _ from 'lodash';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    form: {
      selectedDep: "",
      depName: "",
      depCode: "",
      otherDepartment: "",
      selectedJob: "student",
      studentId: "",
      selectedPost: "",
      postName: "",
      psnName: "",
      emailBefore: "",
      emailAfter: "",
      tel: "",
      selectedPurposes: "",
      purposeName: "",
      purposeCode: "",
      otherPurposes: "",
      selectedDatePattern: "one",
      dateAndResources: [{
        id: 1,
        purposesDate: "",
        purposesDateEnd: "",
        startTime: "",
        endTime: "",
        repetitionSelected: null,
        repetitionPreview: "",
        selectedResources: [],
        treeResources: [],
      }],
      otherText: "",
      takeOutInsurance: "",
      allowTermsOfService: "",
      allowRegistrationByAdmin: false,
    },
  },
  getters: {
    isStudent: state => {
      return state.form.selectedJob === "student";
    },
    isPost: state => {
      return state.form.selectedJob === "post";
    },
    isOtherDepartment: state => {
      return state.form.depCode === "D9999";
    },
    isClubActivities: state => {
      return state.form.purposeCode === "P0050";
    },
  },
  mutations: {
    resetForm(state) {
      state.form = {
        selectedDep: "",
        depName: "",
        depCode: "",
        otherDepartment: "",
        selectedJob: "student",
        studentId: "",
        selectedPost: "",
        postName: "",
        psnName: "",
        finalEmail: "",
        emailBefore: "",
        emailAfter: "",
        tel: "",
        selectedPurposes: "",
        purposeName: "",
        purposeCode: "",
        otherPurposes: "",
        selectedDatePattern: "one",
        dateAndResources: [{
          id: 1,
          purposesDate: "",
          purposesDateEnd: "",
          startTime: "",
          endTime: "",
          repetitionSelected: null,
          repetitionPreview: "",
          selectedResources: [],
        }],
        otherText: "",
        takeOutInsurance: "",
        allowTermsOfService: "",
        allowRegistrationByAdmin: false,
      };
    },
    updateForm(state, payload) {
      // state.form = { ...state.form, ...payload };
      Object.assign(state.form, payload);
    },
    formatStartTime(state, data) {
      state.form.dateAndResources.forEach((d, i) => {
        let val = d.startTime;
        if (i == (data.index) && typeof val != 'undefined' && val != "" && val.length >= 6) {
          d.startTime = val.substring(0, 5);
        }
      });
    },
    formatEndTime(state, data) {
      state.form.dateAndResources.forEach((d, i) => {
        let val = d.endTime;
        if (i == (data.index) && typeof val != 'undefined' && val != "" && val.length >= 6) {
          d.endTime = val.substring(0, 5);
        }
      });
    },
    changeRepetitions(state, data) {
      moment.locale('ja');
      state.form.dateAndResources.forEach((d, i) => {
        if (i == (data.index)) {
          if (d.repetitionSelected == null) {
            d.repetitionPreview = "";
            return;
          }

          let upCount = 0;
          if (d.repetitionSelected == 1) {
            // 毎日
            upCount = 1;
          } else if (d.repetitionSelected == 2) {
            // 毎週
            upCount = 7;
          } else if (d.repetitionSelected == 3) {
            // 隔週
            upCount = 14;
          }

          // 登録される予定の日付を取得して保持する
          let days = [];
          let endDate = moment(data.endDate);
          let next = moment(data.startDate).add(-upCount, 'd');
          while (endDate.isSameOrAfter(next.add(upCount, 'd'))) {
            days.push(_.cloneDeep(next));
          }

          d.repetitionPreview = days.map(day => {
            return day.format('YYYY/MM/DD (ddd)');
          });
        }
      });
    }
  },
  actions: {},
  modules: {},

  // 開発環境でのみ設定
  // strict: true,
});